import defaultConfig from './default.config'
import oldmutualConfig from './oldmutual.config'
import speedyConfig from './speedy.config'
import quickwillConfig from './quickwill.config'
import tebaConfig from './teba.config.js'

const whitelabelConfig = {
  default: defaultConfig,
  quickwill: quickwillConfig,
  speedy: speedyConfig,
  oldmutual: oldmutualConfig,
  teba: tebaConfig
}

function mergeDeep(...objects) {
  const isObject = obj => obj && typeof obj === 'object';
  
  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key];
      const oVal = obj[key];
      
      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = pVal.concat(...oVal);
      }
      else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal);
      }
      else {
        prev[key] = oVal;
      }
    });
    
    return prev;
  }, {});
}

function whitelabel(brand) {
  return mergeDeep(whitelabelConfig.default, whitelabelConfig[brand]) 
}

export default whitelabel
